import { heightImg } from "assets/images";
import CustomButton from "components/form";
import React from "react";

const Question1 = ({ setHeightContent, heightContent ,addOrUpdateQuestion,buttonLoaders,errors}) => {
  console.log(errors,"errors")
  // Handler for updating height content heading or range titles dynamically
  const onChangeHandler = (e, index = null) => {
    const { name, value } = e.target;

    if (name === "heightContentHeading") {
      // Updating the heading
      setHeightContent({ ...heightContent, [name]: value });
    } else if (index !== null) {
      // Updating a specific height range title
      const updatedRanges = [...heightContent.heightContent];
      updatedRanges[index].title = value;
      setHeightContent({ ...heightContent, heightContent: updatedRanges });
    }
  };

  return (
    <>
      <div className="form_field page_title">
        <label className="label">Screen Title</label>
        <input
          type="text"
          className="form-control input"
          name="heightContentHeading"
          value={heightContent.heightContentHeading}
          onChange={onChangeHandler}
        />
          {errors.heightContentHeading && (
          <span className="error">{errors.heightContentHeading}</span>
        )}
      </div>
      <div className="height_info_wrap">
        <div className="image_section">
          <h4>Image</h4>
          <img src={heightImg} alt="" />
        </div>

        <div className="height_info">
          <h4>Height Range Tags</h4>
          {heightContent.heightContent.map((item, index) => (
            <div className="form_field" key={index}>
              <label className="label">{item.range} Inch</label>
              <input
                type="text"
                className="input form-control"
                value={item.title}
                onChange={(e) => onChangeHandler(e, index)}
              />
                {errors[`heightContentTitle${index}`] && (
                <span className="error">{errors[`heightContentTitle${index}`]}</span>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="button_wrap ">
      <CustomButton ref={buttonLoaders} onClick={addOrUpdateQuestion}>Save</CustomButton>
      </div>
    </>
  );
};
export default Question1;
